module.exports = __webpack_public_path__ + "static/media/image22.94ecf709.jpg";